import { useStoreActions } from "../contexts";
import { useSwitchBusiness } from "./useSwitchBusiness";
export function useEnterAccountantAccess() {
  const {
    logBI
  } = useStoreActions();
  const switchBusiness = useSwitchBusiness();
  return function enterAccountantAccess(customerBusinessId, customerCompanyName) {
    logBI(13106, {
      customerId: customerBusinessId,
      companyName: customerCompanyName
    });
    return switchBusiness(customerBusinessId);
  };
}